import React from 'react';
import { TextInput } from '@els/els-react--text-input';

function FullTextFilter({ filter, updateKeywordFilterValue }) {
  return (
    <div className="u-els-margin-bottom-1x1o2">
      <TextInput
        data-e2e="full-text-filter"
        label="Search within results"
        placeholder="Type a keyword to refine the results"
        value={filter.get('userInputValue') || ''}
        onChange={(e) => updateKeywordFilterValue(filter, e.target?.value)}
      />
    </div>
  );
}

export default FullTextFilter;
